<template>
  <claim-blank-form
    submit-label="Сохранить"
    v-bind="$attrs"
    form-type="edit"
    :errors="errors"
    @submit="processClaimForm"
  />
</template>

<script>
import helpers from '@/helpers'
import { updateClaim } from '@/services/claim.service'
import claimBlankForm from '@/components/forms/claim/ClaimBlankForm'

export default {
  name: 'claim-edit-form',
  components: { claimBlankForm },
  inheritAttrs: false,
  data () {
    return {
      errors: {
        claim: {
          id: [],
          text: [],
          datetime: [],
          client: []
        },
        non_field_errors: []
      }
    }
  },
  methods: {
    fillErrors: helpers.fillErrors,

    processClaimForm () {
      this.updateClaim().then((success) => {
        if (success) {
          this.showMsg('Информация была успешно обновлена!', 'success', 'Успешно')
          this.$emit('after', true)
        } else {
          this.$emit('after', false)
        }
      })
    },
    updateClaim () {
      return updateClaim(this.$attrs.claim).then((response) => {
        this.fillErrors(this.errors.claim, {})
        return true
      }).catch(err => {
        this.fillErrors(this.errors.claim, err.response.data)

        if (this.errors.non_field_errors[0]) {
          this.$parent.$parent.showPopupMsg(this.errors.non_field_errors[0], 'error')
        }

        return false
      })
    },
    showMsg (text, type, title) {
      let foundRoot = false
      let $parent = this.$parent

      while (!foundRoot) {
        console.log($parent)
        if ($parent.$parent.$parent === undefined) {
          foundRoot = true
          $parent.showPopupMsg(text, type, title)
        } else {
          $parent = $parent.$parent
        }
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// ClaimEditForm.vue?71f09092